module.exports = __webpack_public_path__ + "img/margherita.bc08f882.png";